module.exports = __webpack_public_path__ + "static/img/P1.32a1eed1.png";